import { useMemo } from "react";
import { CircularProgress, Stack } from "@mui/material";
import { useAppSelector } from ".";

const useLoadingScreen = () => {
    const isLoadingScreenVisible = useAppSelector((state) => state.ui.loading.isActive);

    const screen = useMemo(() => {
        return (
            <Stack justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
                <CircularProgress color="info" />
            </Stack>
          )
    }, [])

    return [isLoadingScreenVisible, screen];
}

export default useLoadingScreen;
